import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  routeType: undefined,
  activeRoute: null,
};

const routeSlice = createSlice({
  name: 'routes',
  initialState,
  reducers: {
    setRouteType: (state, action) => {
      state.routeType = action.payload;
    },
    setActiveRoute: (state, action) => {
      state.activeRoute = action.payload;
    },
  },
});

export const { setRouteType, setActiveRoute } = routeSlice.actions;

export default routeSlice.reducer;
